import { render, staticRenderFns } from "./AddTaskVideo.vue?vue&type=template&id=07e356c4&"
import script from "./AddTaskVideo.vue?vue&type=script&lang=js&"
export * from "./AddTaskVideo.vue?vue&type=script&lang=js&"
import style0 from "./AddTaskVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports